export default function Go_Float () {
  return (
    <div>
      <h1>Go_Float </h1>
      <p>Float</p>
    </div>
  );
}